import React from "react";
import { ConfigProvider } from "antd";
import useTranslation from "utils/hooks/useTranslation";

interface RadioGroupDelayProps {
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export const RadioGroupDelay: React.FC<RadioGroupDelayProps> = ({ name = "delay", value, onChange }) => {
  const { t } = useTranslation();

  const options = [
    { value: "0", label: t("INSTALLATION_SURVEY_ANSWER1") },
    { value: "1", label: t("INSTALLATION_SURVEY_ANSWER2") },
    { value: "2", label: t("INSTALLATION_SURVEY_ANSWER3") },
    { value: "3", label: t("INSTALLATION_SURVEY_ANSWER4") }
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <ConfigProvider>
      <group data-space-vertical="10" role="radiogroup" aria-label="Delay level" data-max-length="700">
        {options.map((option) => (
          <label
            key={option.value}
            radio=""
            data-custom=""
            className=""
            data-name="satisfaction"
            data-length="autofit"
            data-fit="1"
            aria-describedby="«r5t»"
          >
            <input //NOSONAR
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={handleChange}
              aria-hidden="true"
            />
            <box>
              <check></check>
              <ink></ink>
            </box>
            <text>{option.label}</text>
            <separator data-horizontal=""></separator>
          </label>
        ))}
      </group>
    </ConfigProvider>
  );
};
